const state = {
    isOpen: false,
};

const mutations = {
    SET_IS_OPEN(state, payload) {
        state.isOpen = payload;
    },
};

const getters = {
    getIsOpen: state => state.isOpen,
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
